
<div class="main-logo">
  <img class="main-logo" src="/assets/images/my-rest.svg"/>
</div>

<div class="center z-depth-3 mx-auto mt-5" [ngClass]="'center-no-sidebar'">

  <div class="mr-app-container">

    <div *ngIf="!reservationModel.persons || !reservationModel.reservationData"
         style="margin-top: 40px"
         class=" text-center text-bold">
      <div *ngIf="reservationModel.department && reservationModel.department?.message">
        <div class="alert alert-primary" style="margin: 0 10px;">
          <p style="font-size: 13px;line-height: normal;">
            {{ reservationModel.department.message }}
          </p>
        </div>
      </div>
      <span *ngIf="localeModel.code && !reservationModel.department?.message && localeModel.logo_in_widget !== '1'"
            class="ec ec-wave" id="hello-emoji"></span><br>
      <i *ngIf="!reservationModel.department?.message && localeModel.logo_in_widget ==='1'"
         class="large material-icons">
        <img class="welcome-logo" src="{{localeModel.direct_link_logo}}"/>
      </i><br>
      <h4 class="text-uppercase font-weight-bold color-black bold-text">
        {{ 'BOOK.BOOK_TABLE' | translate }}<br>
      </h4>
    </div>

    <div class="container">
      <div *ngIf="reservationModel.department" class="row" style="margin-bottom: 0">
        <!--             [ngClass]="{'hidden': step === 3}"-->

        <div class="col s12 m12">
          <!-- Layout WITH localeEventData -->
          <ng-container *ngIf="localeEventData">
            <!-- Row 1: Department Name (left) + Logo (right) -->
            <div class="event-header">
              <h3><strong>{{ reservationModel.department?.name }}</strong></h3>
              <img class="locale_logo" *ngIf="localeModel.direct_link_logo" [src]="localeModel.direct_link_logo"/>
            </div>

            <!-- Row 2: Event Image -->
            <div class="event-image-container" *ngIf="localeEventData.image_url">
              <img class="event-image" [src]="localeEventData.image_url" />
            </div>

            <!-- Row 3: Event Title (left) + Order Info (right) -->
            <div class="event-info-row">
              <div class="event-title">{{ localeEventData.title }}</div>
              <div class="order-info">
                <div class="order-info-item">
                  <span class="material-symbols-outlined">calendar_month</span>
                  {{ getHumanReservationDate(false) }}
                </div>
                <div class="order-info-item">
                  <span class="material-symbols-outlined">schedule</span>
                  {{ reservationModel.time }}
                </div>
                <div class="order-info-item">
                  <span class="material-symbols-outlined">group</span>
                  {{ reservationModel.persons }} {{ 'RESERVATION.PERSONS' | translate }}
                </div>
              </div>
            </div>

            <!-- Row 4: Event Description -->
            <div class="event-description" *ngIf="localeEventData.description">
              <span [innerHTML]="eventDescriptionExpanded || localeEventData.description.length <= 275
                ? localeEventData.description
                : (localeEventData.description | slice:0:275)"></span><ng-container *ngIf="localeEventData.description.length > 275 && !eventDescriptionExpanded">...</ng-container>
              <a *ngIf="localeEventData.description.length > 275"
                 class="read-more-link"
                 (click)="eventDescriptionExpanded = !eventDescriptionExpanded">{{ eventDescriptionExpanded ? ('EVENT.READ_LESS' | translate) : ('EVENT.READ_MORE' | translate) }}</a>
            </div>
          </ng-container>

          <!-- Layout WITHOUT localeEventData (original) -->
          <ng-container *ngIf="!localeEventData">
            <img class="locale_logo" *ngIf="localeModel.direct_link_logo" [src]="localeModel.direct_link_logo"/>
            <h3><strong>{{ reservationModel.department?.name }}</strong></h3>
            <div class="order-info">
              <div class="order-info-item">
                <span class="material-symbols-outlined">calendar_month</span>
                {{ getHumanReservationDate(false) }}
              </div>
              <div class="order-info-item">
                <span class="material-symbols-outlined">schedule</span>
                {{ reservationModel.time }}
              </div>
              <div class="order-info-item">
                <span class="material-symbols-outlined">group</span>
                {{ reservationModel.persons }} {{ 'RESERVATION.PERSONS' | translate }}
              </div>
            </div>
          </ng-container>
        <div class="order-sum mt-3" *ngIf="reservationModel.department.payment_required && (!localeEventData || !localeEventData.price)">
          <span class="material-symbols-outlined">notifications</span>
          {{ 'RESERVATION.REQUIRED_DEPOSIT' | translate }} {{ reservationModel.department.payment_val }} {{ 'RESERVATION.PAYMENT_CURRENCY' | translate }}
          <ng-container *ngIf="price_depends_on_persons"> {{ 'RESERVATION.PER_PERSON' | translate }}. {{ 'RESERVATION.TOTAL_AMOUNT' | translate }}: {{ reservationModel.department.payment_total }} {{ 'RESERVATION.PAYMENT_CURRENCY' | translate }}</ng-container>
        </div>
          <div class="order-sum mt-3" *ngIf="reservationModel.department.payment_required && localeEventData && localeEventData.price">
            <span class="material-symbols-outlined">notifications</span>
            {{ 'RESERVATION.REQUIRED_DEPOSIT' | translate }} {{ getEventDisplayPrice() }} {{ 'RESERVATION.PAYMENT_CURRENCY' | translate }}
            <ng-container *ngIf="isEventPricePerPerson()"> {{ 'RESERVATION.PER_PERSON' | translate }}. {{ 'RESERVATION.TOTAL_AMOUNT' | translate }}: {{ reservationModel.price ?? reservationModel.persons * getEventDisplayPrice() }} {{ 'RESERVATION.PAYMENT_CURRENCY' | translate }}</ng-container>
          </div>
          <hr>

          <div class="loader-block"
            *ngIf="requestInProcess || reservationPaymentInProgress">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only"></span>
            </div>
            <p>{{ 'BOOK.PAYMENT_WAITING' | translate }}</p>
          </div>
      </div>


      <div *ngIf="localeModel && personsList">
        <h6 *ngIf="!reservationModel.persons || !reservationModel.reservationData" style="color: #fff"
            class=" text-center">{{ 'BOOK.INFO' | translate }}</h6>
        <div [ngClass]="{'hidden': step === 2 || step === 3}" style="opacity: 0">

          <div class="row bounce" [ngClass]="{'mt-5': !reservationModel.persons || !reservationModel.reservationData}"
               style="padding: 20px;">
            <div class="col col-md-6">
              <div class="people-select">
                <div class="input-field mb-0">
                  <select
                    id="mr-persons-lisiscolt"
                    class="main-page-select form-control w-100"
                    [(ngModel)]="reservationModel.persons"
                    [ngModelOptions]="{standalone: true}"
                    (change)="checkAvailableTimesTimes()">
                    <option value="0">{{ 'BOOK.AMOUNT' | translate }}</option>
                    <option *ngFor="let amount of personsList"
                            [ngValue]="amount.amount">{{ amount.amount }} {{ amount.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col col-md-6">
              <div class="date-select">
                <div class="input-field  mb-0">

                  <input
                    readonly
                    type="text"
                    #dp="bsDatepicker"
                    class="form-control reservationDatePicker"
                    bsDatepicker
                    [(ngModel)]="reservationModel.reservationData"
                    [bsConfig]="{
                            adaptivePosition: false,
                            dateInputFormat: 'DD MMMM YYYY',
                            showWeekNumbers: false,
                            startingDay: 1
                        }"
                    [daysDisabled]="reservationDaysDisabled"
                    [datesDisabled]="disabledDates"
                    (ngModelChange)="checkAvailableTimesTimes()"
                    [placeholder]="getTranslation('BOOK.DATE')"
                    [minDate]="minReservationDate"
                    [maxDate]="maxReservationDate"
                  >
                </div>
              </div>
            </div>

            <p style="color: #878684; text-align: center; font-size: 15px; padding-top: 10px; margin-bottom: 0;"
               *ngIf="reservationModel.department.payment_val && reservationModel.department.payment_required">
              ℹ️
              {{ 'BOOK.PAYMENT_REQUIRED' | translate }}
              {{ reservationModel.department.payment_val }}
              {{ 'BOOK.PAYMENT_CURRENCY' | translate }}
            </p>

            <div
              *ngIf="reservationModel.persons && reservationModel.reservationData  && reservationModel.department.halls && reservationModel.department.halls.length > 1"
              class=" w-100">
              <div>
                <div class="input-field  mb-0 mt-3">
                  <select class="form-control w-100"
                          [(ngModel)]="reservationModel.preferred_hall_id"
                          [ngModelOptions]="{standalone: true}"
                          (change)="checkAvailableTimesTimes()">
                    <option value="0">{{ 'BOOK.HALL_SELECT' | translate }}</option>
                    <option *ngFor="let hall of reservationModel.department.halls"
                            [ngValue]="hall.id">{{ hall.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div
              *ngIf="reservationModel.persons && reservationModel.reservationData && department.durationOptions.length > 0"
              class=" w-100">
              <p class="reservation-label">{{ ('BOOK.RESERVATION_DURATION_LABEL' | translate) }}:</p>
              <div>
                <div class="btn-group w-100" role="group">
                        <span *ngFor="let durationOption of department.durationOptions; let index = index;"
                              [ngClass]="{'btn-inactive': reservationModel.duration_id !== durationOption.id}"
                              (click)="setReservationDuration(durationOption)"
                              class="btn btn-inactive duration-option" href="#">
                          {{ durationOption.hours > 0 ? durationOption.hours : '' }} <span class="button-group-time"
                                                                                           *ngIf="durationOption.hours > 0">{{ ('BOOK.RESERVATION_HOURS' | translate) }}
                          .</span>  {{ durationOption.minutes > 0 ? durationOption.minutes : '' }} <span
                          class="button-group-time"
                          *ngIf="durationOption.minutes > 0">{{ ('BOOK.RESERVATION_MINUTES' | translate) }}.</span>
                        </span>
                </div>
              </div>
            </div>

            <div class=" w-100"
                 *ngIf="reservationModel.persons && reservationModel.reservationData">
              <p class="reservation-label">{{ ('BOOK.RESERVATION_TIME' | translate) }}:</p>
              <div class="collection mr-time-aviable-container"
                   [ngClass]="{'short': reservationModel.department.halls && reservationModel.department.halls.length > 1}">
                <div
                  id="no-time-slots-handler"
                  class="text-center "
                  *ngIf="reservationTimeSlots && reservationTimeSlots.length == 0">
                  <span class="ec ec-male-detective" style="font-size: 50px;"></span>
                  <div *ngIf="reservationTimeSlotsMessageCode == 1;else other_content">
                    <h3>{{ ('BOOK.NO_TIME_SLOTS_TITLE_TODAY' | translate) }}</h3>
                    <p>{{ ('BOOK.NO_TIME_SLOTS_DESCRIPTION_TODAY' | translate) }}</p>
                  </div>
                  <ng-template #other_content>
                    <div>
                      <h3>{{ ('BOOK.NO_TIME_SLOTS_TITLE' | translate) }}</h3>
                      <p>{{ ('BOOK.NO_TIME_SLOTS_DESCRIPTION' | translate) }}</p>
                    </div>
                  </ng-template>
                </div>
                <div *ngIf="reservationTimeSlots && reservationTimeSlots.length > 0">
                  <a *ngFor="let time of reservationTimeSlots; let i = index"
                     [ngClass]="{
                       'active': time_active === i,
                       'slot-available': time.available === 1,
                       'slot-queued': time.available === 2,
                       'slot-unavailable': !time.available
                     }"
                     (click)="processTimeClick(time, i)"
                     class="collection-item mr-text-left"
                  >
                    <div class="slot-inner">
                      <span class="slot-left">
                        <span class="slot-dot" [class.invisible]="!time.available"></span>
                        <span class="slot-time">{{ time.time }}</span>
                        <span *ngIf="time.paid" class="paid-indicator">$</span>
                      </span>
                      <span class="slot-status">
                        {{ time.available === 1 ? ('BOOK.ACTION' | translate) : time.available === 2 ? ('BOOK.ASK_FOR_TABLE' | translate) : ('BOOK.NO_PLACES' | translate) }}
                        <span *ngIf="time.available">&rsaquo;</span>
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="next_step">
            <div class="fixed-action-btn mr-action-btn">
              <a class="btn-floating btn-large red waves-effect waves-light  scale-transition"
                 (click)="step = 2">
                <i class="large material-icons pulse">navigate_next</i>
              </a>
            </div>
          </ng-container>
        </div>

        <div [ngClass]="{'hidden': step === 1 || step === 3 || requestInProcess || reservationPaymentInProgress }">
          <div>
            <span class="comment">{{ 'RESERVATION.COMPLETE_THE_FORM' | translate }}</span>
            <form id="reservation-form" #f="ngForm" [formGroup]="phoneForm">
              <div class="mb-2">
                <label for="name" class="form-label">{{ 'RESERVATION.NAME' | translate }}</label>
                <input id="name"
                       class="form-control validate"
                       type="text"
                       placeholder="{{ 'RESERVATION.NAME_PLACEHOLDER' | translate }}"
                       [(ngModel)]="reservationModel.name"
                       [disabled]="reservation_id"
                       [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="checkReservationModelErrors('name')"
                >
                <span class="error-message" *ngIf="reservationModelErrors.name">{{ 'RESERVATION.ERROR.NAME' | translate }}</span>
              </div>
              <div class="mb-2">
                <label for="reservation-email" class="form-label">{{ 'BOOK.EMAIL' | translate }}</label>
                <input id="reservation-email"
                       class="form-control validate"
                       type="email"
                       placeholder="{{ 'RESERVATION.EMAIL_PLACEHOLDER' | translate }}"
                       [(ngModel)]="reservationModel.email"
                       [ngModelOptions]="{standalone: true}"
                       [disabled]="reservation_id"
                       (ngModelChange)="checkReservationModelErrors('email')">
                <span class="error-message" *ngIf="reservationModelErrors.email">{{ 'RESERVATION.ERROR.EMAIL' | translate }}</span>
              </div>
              <div class="mb-2">
                <label for="reservation-phone" class="form-label">{{ 'BOOK.PHONE' | translate }}</label>
                <ngx-intl-tel-input
                  id="reservation-phone"
                  style="display: block;width: 100%;"
                  [(ngModel)]="reservationModel.phone"
                  [enablePlaceholder]="true"
                  [disabled]="reservationModel.id !== 0"
                  [enableAutoCountrySelect]="true"
                  [preferredCountries]="['pl']"
                  name="phone"
                  (ngModelChange)="checkReservationModelErrors('phone')"
                  formControlName="phone">
                </ngx-intl-tel-input>
                <span class="error-message" *ngIf="reservationModelErrors.phone">{{ 'RESERVATION.ERROR.PHONE' | translate }}</span>
              </div>

              <div class="mb-3">
                <label for="message" class="form-label">{{ 'RESERVATION.MESSAGE' | translate }}</label>
                <textarea id="message"
                       class="form-control validate"
                       [(ngModel)]="reservationModel.message"
                          [disabled]="reservation_id"
                       placeholder="{{ 'RESERVATION.MESSAGE_PLACEHOLDER' | translate }}"
                       rows="2"
                       name="message"
                          [ngModelOptions]="{standalone: true}"></textarea>
              </div>
              <div class="terms">
                <p *ngIf="reservationModel.department.payment_required">{{ 'RESERVATION.RESERVATION_TERMS_MESSAGE' | translate }} <a (click)="showReservationPaymentRegulamin(reservationPaymentModal)" class="blue-text">{{ 'RESERVATION.RESERVATION_TERMS' | translate }}</a>.</p>

                <div class="mb-2" *ngIf="localeModel.reservations_payments_terms && localeModel.reservations_payments_terms_required > 0">
                  <input type="checkbox"
                         id="checkbox-agreement"
                         class="filled-in"
                         [(ngModel)]="reservationModel.agreement"
                         (ngModelChange)="checkReservationModelErrors('checkbox_privacy')"
                         [ngModelOptions]="{standalone: true}">
                  <label for="checkbox-agreement" class="mr-terms-label">
                    {{ 'MENU.AGREEMENT_CHECKBOX' | translate }} <a (click)="showReservationPaymentRegulamin(reservationPaymentModal); false" style="text-decoration: underline; cursor: pointer" class="blue-text">{{ 'MENU.AGREEMENT_CHECKBOX_TERMS' | translate }}</a><span style="color: red;">&nbsp;*</span>
                    <span class="error-message" *ngIf="reservationModelErrors.checkbox_agreement">{{ 'RESERVATION.ERROR.REQUIRED' | translate }}</span>
                  </label>
                </div>
                <div class="mb-2">
                  <input type="checkbox"
                         id="checkbox-privacy"
                         class="filled-in"
                         [(ngModel)]="reservationModel.checkbox_privacy"
                         (ngModelChange)="checkReservationModelErrors('checkbox_privacy')"
                           [ngModelOptions]="{standalone: true}">
                    <label for="checkbox-privacy" class="mr-terms-label">
                      {{localeModel.privacy_short}} <a (click)="showPrivacy(privacyModal); false" style="text-decoration: underline; cursor: pointer" class="blue-text">{{ 'BOOK.PRIVACY_SHORT_MORE' | translate }}</a><span style="color: red;">&nbsp;*</span>
                      <span class="error-message" *ngIf="reservationModelErrors.checkbox_privacy">{{ 'RESERVATION.ERROR.REQUIRED' | translate }}</span>
                    </label>
                </div>
                <div class="mb-2">
                  <input type="checkbox"
                         id="checkbox-terms"
                         class="filled-in"
                         [(ngModel)]="reservationModel.checkbox_terms"
                         (ngModelChange)="checkReservationModelErrors('checkbox_terms')"
                           [ngModelOptions]="{standalone: true}">
                  <label for="checkbox-terms" class="mr-terms-label">
                    {{ localeModel.marketing_consent_short }} <a (click)="showMarketing(marketingModal); false" class="blue-text">{{ 'BOOK.PRIVACY_SHORT_MORE' | translate }}</a>
                    <span class="error-message" *ngIf="reservationModelErrors.checkbox_terms">{{ 'RESERVATION.ERROR.REQUIRED' | translate }}</span>
                  </label>
                </div>
              </div>

            </form>

            <hr>
            <div class="row mb-0">
              <div class="col col-12">

                <ng-container>
<!--                  *ngIf="can_finish(f) && !requestInProcess">-->
                  <div class="fixed-action-btn mr-action-btn mt-4" id="step-2-finish">
                    <a id="mr-finish-btn"
                       class="btn-large blue waves-effect waves-light scale-transition"
                       [class.disabled]="requestInProcess"
                       (click)="sendReservation()">
                      {{ (reservationModel.department.payment_required ? 'RESERVATION.GO_TO_PAYMENT' : 'BOOK.MAKE_RESERVATION') | translate }}
                    </a>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div [ngClass]="{'hidden': step === 1 || step === 2}">
          <div class="container content-container">
            <div class="" *ngIf="!reservationModel.reservation_code">
              <div class="preloader-wrapper active mr-loader-position">
                <div class="spinner-layer spinner-red-only">
                  <div class="circle-clipper left">
                    <div class="circle"></div>
                  </div>
                  <div class="gap-patch">
                    <div class="circle"></div>
                  </div>
                  <div class="circle-clipper right">
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="reservationModel.reservation_code"
                 style="margin-top: 40px; color: #878684;">
              <div class="m12 s12 col text-center"
                   *ngIf="reservationModel.department.payment_required == 1 && reservationModel.payment_url">

                <h5 *ngIf="reservationPaymentCompleted">
                  <p
                    *ngIf="reservationPaymentCompletedStatus == 1 || reservationPaymentCompletedStatus == 2">{{ 'BOOK.PAYMENT_THANKS' | translate }}</p>
                  <div *ngIf="reservationPaymentCompletedStatus == 5">
                    <p>{{ 'BOOK.PAYMENT_FAILED' | translate }}</p>
                    <button
                      type="button" class="btn btn-success"
                      style="margin-top: 20px"
                      (click)="cleanReservation()">
                      {{ 'BOOK.PAYMENT_FAILED_NEW_BTN' | translate }}
                    </button>
                  </div>
                </h5>

                <div *ngIf="!reservationPaymentInProgress && !reservationPaymentCompleted">
                  <p style="font-size: 15px;">
                    {{ 'BOOK.PAYMENT_INFO_REGULAMIN_LABEL' | translate }} <span
                    (click)="showReservationPaymentRegulamin(reservationPaymentModal)"
                    style="text-decoration: underline; cursor: pointer">{{ 'BOOK.PAYMENT_INFO_REGULAMIN_BTN' | translate }}</span>
                  </p>
                  <button
                    type="button" class="btn btn-success"
                    style="margin-top: 20px"
                    (click)="openLink(reservationModel.payment_url)">
                    {{ 'BOOK.PAY_BTN' | translate }}
                    ({{ reservationModel.department.payment_val }} {{ 'BOOK.PAYMENT_CURRENCY' | translate }})
                  </button>
                </div>
              </div>

              <!-- Queued reservation (queue mode) -->
              <div class="m12 s12 col text-center queued-confirmation"
                   *ngIf="reservationModel.is_queued == 1 && reservationModel.department.payment_required != 1">
                <div class="queued-badge">
                  <span class="queued-badge-dot"></span>
                  {{ 'BOOK.QUEUED_BADGE' | translate }}
                </div>
                <div class="queued-icon">&#9203;</div>
                <h5 class="queued-title">{{ 'BOOK.QUEUED_TITLE' | translate }}</h5>
                <p class="queued-status" [innerHTML]="'BOOK.QUEUED_STATUS' | translate:{ time: reservationModel.time }"></p>
                <div class="queued-info-box">
                  <span class="queued-info-icon">&#9432;</span>
                  {{ 'BOOK.QUEUED_INFO' | translate }}
                </div>
                <div class="queued-details">
                  <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                  <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                  <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                  <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                  <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                </div>
              </div>

              <div class="m12 s12 col text-center queued-confirmation"
                   *ngIf="reservationModel.is_queued != 1 && reservationModel.reservation_status == 1 && reservationModel.department.payment_required != 1">
                <h6><span class="ec ec-white-check-mark" style="font-size: 60px;"></span></h6>
                <h5>{{ 'BOOK.DONE' | translate }}</h5>
                <h6>{{ 'BOOK.DONE_STATUS' | translate }}</h6>
                <div class="queued-details">
                  <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                  <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                  <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                  <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                  <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                </div>
              </div>
              <div class="m12 s12 col text-center queued-confirmation"
                   *ngIf="reservationModel.is_queued != 1 && reservationModel.reservation_status != 1 && reservationModel.department.payment_required != 1">
                <h6><span class="ec ec-clock1" style="font-size: 60px;"></span></h6>
                <h5>{{ 'BOOK.ADDED' | translate }}</h5>
                <h6>{{ 'BOOK.WAIT_STATUS' | translate }}</h6>
                <div class="queued-details">
                  <span class="queued-chip"><span class="queued-chip-icon">👥</span> {{reservationModel.persons}} {{ 'BOOK.PERSONS' | translate }}</span>
                  <span class="queued-chip"><span class="queued-chip-icon">📆</span> {{reservationModel.reservationData | date:'dd MMMM yyyy'}}</span>
                  <span class="queued-chip"><span class="queued-chip-icon">🕑</span> {{reservationModel.time}}</span>
                  <span class="queued-chip"><span class="queued-chip-label">{{ 'BOOK.RESTAURANT' | translate }}</span> <strong>{{reservationModel.department.name}}</strong></span>
                  <span class="queued-chip">{{ 'BOOK.BOOK_CODE' | translate }}: <strong>{{reservationModel.reservation_code}}</strong></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div id="privacy_delivery_handler" [ngClass]="privacyDeliveryHandlerOpenedStyle">
      <div class="close-handler">
        <i class="small material-icons close-privacy-btn" [ngClass]="privacyDeliveryButtonCloseStyle"
           (click)="showDeliveryPrivacy(false)">close</i>
      </div>
      <p style="white-space: pre-line">
        {{ localeModel.privacy_delivery_full }}<br><br>
      </p>
    </div>

    <div id="terms_handler" [ngClass]="termsHandlerOpenedStyle">
      <div class="close-handler">
        <i class="small material-icons close-privacy-btn" [ngClass]="termsButtonCloseStyle"
           (click)="showDeliveryTerms(false)">close</i>
      </div>
      <p style="white-space: pre-line">
        {{ localeModel.delivery_terms }}<br><br>
      </p>
    </div>
  </div>

  <ng-template #reservationPaymentModal>
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{ 'BOOK.PAYMENT_INFO_REGULAMIN_POPUP_TITLE' | translate }}</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close"
              (click)="reservationPaymentModalRef?.hide()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      {{ localeModel.reservations_payments_terms }}
      <button (click)="reservationPaymentModalRef?.hide()" class="btn btn-primary btn-green w-100">OK</button>
    </div>
  </ng-template>

  <ng-template #privacyModal>
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{ 'BOOK.PRIVACY_POLICY' | translate }}</h4>
      <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="privacyModalRef?.hide()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      {{ localeModel.privacy_full }}
      <div class="text-center" *ngIf="this.localeModel.privacy_url">
        <br><br>
        <a class="green-color" href="{{this.localeModel.privacy_url}}" target="_blank"
           rel="noreferrer">{{ 'BOOK.PRIVACY_POLICY_LINK' | translate }}</a>
      </div>
      <br><br>
      <button (click)="privacyModalRef?.hide()" class="btn btn-primary btn-green w-100">OK</button>
    </div>
  </ng-template>

    <ng-template #marketingModal>
      <div class="modal-header">
        <h4 class="modal-title pull-left">{{ 'BOOK.PRIVACY_POLICY' | translate }}</h4>
        <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="marketingModalRef?.hide()">
          <span aria-hidden="true" class="visually-hidden">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p style="white-space: pre-line">
          {{localeModel.marketing_consent_full}}<br><br>
        </p>
        <br><br>
        <button (click)="marketingModalRef?.hide()" class="btn btn-primary btn-green w-100">OK</button>
      </div>
    </ng-template>

  </div>
</div>

